import axios from 'axios';

export const protalNameBaseUrl = "https://portalbe.speediv.com"; //"https://portalBeTest.malkali.com"; //"https://portalbe.speediv.com"; //"https://portalBeTest.malkali.com"; //"https://portalbe.speediv.com"; //"https://portalBeTest.malkali.com"; // "https://test-portal-be.malkali.com"; //"https://portalBeTest.malkali.com"; //"https://portalBe.malkali.com"; //

const inst = axios.create({baseURL: protalNameBaseUrl });
//const inst = axios.create({baseURL: "https://newtest.westeurope.cloudapp.azure.com" });
export default inst;